import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Modal from '@Components/Common/Modal';
import TX from '@Components/Common/Text';
import Button from '@Components/Common/Button';

const NetworkOfflineModal = ({ isNetworkConnected }) => {
  const [isNetworkOfflineModalVisible, setIsNetworkOfflineModalVisible] = useState(!isNetworkConnected);

  const handleIsNetworkOfflineModalVisible = useCallback(() => {
    setIsNetworkOfflineModalVisible(!isNetworkOfflineModalVisible);
  }, [isNetworkOfflineModalVisible]);

  useEffect(() => {
    setIsNetworkOfflineModalVisible(!isNetworkConnected);
  }, [isNetworkConnected]);

  return (
    <Modal isShowCloseButton={false} visible={isNetworkOfflineModalVisible}>
      <ModalContentContainer>
        <NetworkOfflineText>인터넷 연결 끊김</NetworkOfflineText>

        <NetworkOfflineInfoText>
          오프라인 작업 중 문서는 임시 저장 되지만
          <br />
          오류가 생길 수 있습니다.
        </NetworkOfflineInfoText>
      </ModalContentContainer>

      <Button
        text="계속 작성"
        textColor="#0A0A0A"
        backgroundColor="#F2F2F3"
        onClick={handleIsNetworkOfflineModalVisible}
      />
    </Modal>
  );
};

NetworkOfflineModal.propTypes = {
  isNetworkConnected: PropTypes.bool.isRequired,
};

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 96px;

  margin-top: 44px;
  margin-bottom: 16px;
`;

const NetworkOfflineText = styled(TX.Title1)`
  margin-bottom: 13px;
`;

const NetworkOfflineInfoText = styled(TX.BodyM)`
  text-align: center;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.ui_on_2};
`;

export default NetworkOfflineModal;
